// ペンの色・太さの選好を localStorage に保存する。

const COLOR_KEY = "refinement-canvas:pen:color";
const THICKNESS_KEY = "refinement-canvas:pen:thickness";

export type PenColor = "black" | "red" | "blue";
export type PenThickness = "thin" | "medium" | "thick";

const VALID_COLORS: readonly PenColor[] = ["black", "red", "blue"];
const VALID_THICKNESS: readonly PenThickness[] = ["thin", "medium", "thick"];

const DEFAULT_COLOR: PenColor = "black";
const DEFAULT_THICKNESS: PenThickness = "medium";

export function loadPenColor(): PenColor {
  try {
    const value = window.localStorage.getItem(COLOR_KEY);
    return VALID_COLORS.find((c) => c === value) ?? DEFAULT_COLOR;
  } catch {
    return DEFAULT_COLOR;
  }
}

export function savePenColor(color: PenColor): void {
  try {
    window.localStorage.setItem(COLOR_KEY, color);
  } catch {
    // ignore（プライベートブラウジング等）
  }
}

export function loadPenThickness(): PenThickness {
  try {
    const value = window.localStorage.getItem(THICKNESS_KEY);
    return VALID_THICKNESS.find((c) => c === value) ?? DEFAULT_THICKNESS;
  } catch {
    return DEFAULT_THICKNESS;
  }
}

export function savePenThickness(thickness: PenThickness): void {
  try {
    window.localStorage.setItem(THICKNESS_KEY, thickness);
  } catch {
    // ignore
  }
}

export const PEN_THICKNESS_PIXELS: Record<PenThickness, number> = {
  thin: 2,
  medium: 4,
  thick: 8,
};

export const PEN_COLOR_HEX: Record<PenColor, string> = {
  black: "#1a1a2e",
  red: "#d22b2b",
  blue: "#1e63d4",
};
